<app-progress-spinner 
  [color]="color" 
  class="example-spinnet-two" 
  [mode]="mode" 
  [value]="value" 
  [backdropEnabled]="true" 
  [positionGloballyCenter]="true" 
  [displayProgressSpinner]="allStatus$.displayProgressSpinner()">
</app-progress-spinner>
<router-outlet />